import { createGlobalStyle } from 'styled-components';
const amsiProSrc = [
    require('../../assets/fonts/AmsiProNormal-Black.woff'),
    require('../../assets/fonts/AmsiProNormal-Black.woff2'),
];
const hindMaduraiBoldSrc = [
    require('../../assets/fonts/HindMadurai-Bold.woff'),
    require('../../assets/fonts/HindMadurai-Bold.woff2'),
];
const hindMaduraiNormalSrc = [
    require('../../assets/fonts/HindMadurai-Normal.woff'),
    require('../../assets/fonts/HindMadurai-Normal.woff2'),
];
export const GlobalStyle = createGlobalStyle `
  @font-face {
    font-display: swap;
    font-family: 'Amsi Pro Normal';
    font-style: normal;
    font-weight: 900;
    src: url(${amsiProSrc[1]}) format('woff2'),
      url(${amsiProSrc[0]}) format('woff');
  }

  @font-face {
    font-display: swap;
    font-family: 'Hind Madurai';
    font-style: normal;
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    src: url(${hindMaduraiBoldSrc[1]}) format('woff2'),
      url(${hindMaduraiBoldSrc[0]}) format('woff');
  }

  @font-face {
    font-display: swap;
    font-family: 'Hind Madurai';
    font-style: normal;
    font-weight: ${({ theme }) => theme.fontWeights.normal};
    src: url(${hindMaduraiNormalSrc[1]}) format('woff2'),
      url(${hindMaduraiNormalSrc[0]}) format('woff');
  }

  *, *::after, *::before {
    box-sizing: border-box;
    font-family: ${({ theme }) => theme.fonts.body};
    font-size: 100%;
    font-weight: ${({ theme }) => theme.fontWeights.normal};
    margin: 0;
    outline: 0;
    padding: 0;
    vertical-align: baseline;
  }

  #__next {
    min-height: 100vh;
  }

  img {
    height: auto;
    max-width: 100%;
  }

  input, textarea {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.black};
  }
`;
//# sourceMappingURL=index.js.map